import { FeatureFlagsBootstrap } from "@/interfaces/IFeatureFlags";
import { axiosInstance, BACKEND, parseResponse } from "@/services";

const FEATURE_FLAGS_API_URL = BACKEND?.endsWith("/")
  ? `${BACKEND}api/feature-flags/v1`
  : `${BACKEND}/api/feature-flags/v1`;

export const getFeatureFlagsBootstrap = async () => {
  try {
    const response = await axiosInstance.get<FeatureFlagsBootstrap>(
      `${FEATURE_FLAGS_API_URL}/bootstrap`,
      {
        params: { app: "customer-web" },
        headers: {
          "x-wisterias-app": "customer-web",
        },
      }
    );

    return parseResponse(response) as FeatureFlagsBootstrap;
  } catch (error: any) {
    return parseResponse(error.response);
  }
};
